import React from 'react';
import styled, { css } from 'styled-components';

import { convertThumbnailToPictureProps } from '@tager/web-modules';

import { selectSinglePost } from '@/store/reducers/single-post';
import Picture from '@/components/Picture';
import { useTypedSelector } from '@/store/store';
import { media } from '@/utils/mixin';

import Author from './components/Author';

function Home() {
  const page = useTypedSelector(selectSinglePost);

  if (!page) {
    return null;
  }

  return (
    <Component>
      <Image>
        <StyledPicture
          loading="lazy"
          {...convertThumbnailToPictureProps(page.image)}
          alt={(page?.title ?? '') + ' #1'}
        />
      </Image>

      <Content>
        <ContentContainer>
          <Top>
            <Title id="post-title">{page.title}</Title>
            <Subtitle id="post-subtitle">{page.excerpt}</Subtitle>
          </Top>

          <Author
            authorName={page.authorName}
            authorText={page.authorText}
            avatar={page.authorImage}
          />
        </ContentContainer>
      </Content>
    </Component>
  );
}

export default Home;

const Component = styled.div`
  display: flex;
  width: 100%;

  ${media.tabletSmall(
    css`
      display: block;
    `
  )}
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 36px 20px 52px 20px;

  ${media.tabletSmallUp(
    css`
      order: 1;
      justify-content: center;
    `
  )};

  @media (min-width: 1400px) {
    padding: 90px;
  }

  ${media.tabletSmall(
    css`
      padding: 40px 20px;
    `
  )}
`;

const ContentContainer = styled.div``;

const Top = styled.div`
  margin: 40px 0 50px;
  display: flex;
  flex-direction: column;

  ${media.tabletSmall(
    css`
      margin: 40px 0 0;
    `
  )}

  ${media.mobile(
    css`
      margin: 0;
    `
  )}
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 22px;
  line-height: 33px;
  margin: 0;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    font-size: 40px;
    line-height: 75px;
  }
`;

const Subtitle = styled.p`
  font-weight: 300;
  font-size: 20px;
  line-height: 130%;
  margin-top: 10px;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    font-size: 22px;
    line-height: 33px;
    margin-top: 20px;
  }
`;

const Image = styled.div`
  position: relative;
  width: 100%;

  overflow: hidden;

  ${media.tabletSmallUp(
    css`
      order: 2;
    `
  )}
`;

const StyledPicture = styled(Picture)`
  position: relative !important;
  width: 100%;
  height: 100%;

  picture {
    width: 100%;
    height: 100%;
  }

  img {
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
  }
`;
